module.exports = __webpack_public_path__ + "img/022.5ea69d89.jpg";